import { PropTypes } from "prop-types";
import { FormControlLabel, Checkbox } from "@mui/material";

const propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const CheckboxControl = ({ label, checked, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox checked={checked} onChange={onChange} color="primary" />
      }
      label={label}
    />
  );
};

CheckboxControl.propTypes = propTypes;

export default CheckboxControl;
